import { NuxtClientBase } from './client.base'

export class NuxtWebview extends NuxtClientBase {
  async init() {
    try {
      this.gaApp.services.app.main.initWebview()

      this.initAppInterceptors()

      this.gaApp.services.app.main.fillDeviceId()

      await this.loadSources()

      await this.prepareData()

      this.initWindowResizeListener()

      this.initCurrentBreakpoint()

      this.detectHoverMedia()
      this.initKeyboardAndPointerListener()

      this.setLocale()

      this.setUserViewGUID()

      this.initAnalytics()

      this.gaApp.router.afterEach(() => {
        if (!this.gaApp.isInit) {
          this.completeAppInit()
        }
      })
    } catch (error) {
      this.onInitError(error, 'INIT-webview')
    }
  }
}
